import {QueryKey} from '@config/queryKeys';
import {http} from '@http/http';
import {useQuery} from '@tanstack/react-query';

export const useHLSStreamQuery = (streamUrl: string) => {
    const query = useQuery({
        queryKey: QueryKey.LIVE_EVENT_STREAM(streamUrl),
        queryFn: async () => {
            const streamRes = await http.get(streamUrl);
            return streamRes;
        },
        refetchInterval: 30 * 1000,
        retry: false,
        refetchOnMount: true,
        staleTime: 0,
    });

    return query.status === 'success';
};
